import { tokens } from '@cellula/react-theme-patient';
import { Text } from '@visiba-cortex/react-ui-std';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { StickyTopBannerLeapScrollVariant } from './_sticky_top_banner_variant_leap_scroll.component';
import { StickyTopBannerStickyScrollVariant } from './_sticky_top_banner_variant_sticky_scroll.component';

const elements = {
	container: styled.header`
		z-index: 1;
		position: fixed;
		top: var(--header-height);
		left: 0;
		right: 0;
		overflow: hidden;
	`,
};

interface Props {
	variant?: 'stickyScroll' | 'leapScroll';
	children: ReactNode;
}

export function StickyTopBanner({ children, variant = 'stickyScroll' }: Props): JSX.Element {
	let VariantComponent: (args: { children: ReactNode }) => JSX.Element;
	switch (variant) {
		case 'stickyScroll':
			VariantComponent = StickyTopBannerStickyScrollVariant;
			break;
		case 'leapScroll':
			VariantComponent = StickyTopBannerLeapScrollVariant;
			break;
	}

	return (
		<elements.container aria-hidden>
			<VariantComponent>
				<Text font={tokens.text.body.regular} color={tokens.color.content.muted}>
					{children}
				</Text>
			</VariantComponent>
		</elements.container>
	);
}
